import React, { useRef, createContext, useState, useEffect } from 'react';
import { DiscordSDK, patchUrlMappings } from "@discord/embedded-app-sdk";
import { BASEJUMP_API_DOMAIN } from '../constants';
import {
  getDiscordToken,
} from './BasejumpApiProvider';
import { DISCORD_SERVER_INVITE_URL } from '../constants';

export const DiscordSdkContext = createContext();

export const DiscordSdkProvider = ({ discordAppId, children }) => {
  const [discordSdk, setDiscordSdk] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDiscord, setIsDiscord] = useState(false);
  const [discordToken, setDiscordToken] = useState(null);
  const authingRef = useRef(false);
  const setupSdk = async () => {
    let keepLoading = false;
    try {
      const discordSdk = new DiscordSDK(discordAppId);
      const context = await discordSdk.ready();
      patchUrlMappings([
        {
          prefix: '/cloudinary',
          target: 'res.cloudinary.com'
        },
        {
          prefix: '/upload',
          target: 'basejump-assets.s3.us-east-1.amazonaws.com/assets-prod/upload'
        },
        {
          prefix: '/items',
          target: 'd9mwibab5tete.cloudfront.net/items'
        },
        {
          prefix: '/gameserver',
          target: BASEJUMP_API_DOMAIN
        },
        {
          prefix: '/assets-prod',
          target: 'd9mwibab5tete.cloudfront.net/assets-prod'
        },
        {
          prefix: '/arweave',
          target: 'arweave.net'
        },
        {
          prefix: '/matchmaker',
          target: 'matchmaker.services.api.unity.com'
        },
        {
          prefix: '/player-auth',
          target: 'player-auth.services.api.unity.com'
        },
        {
          prefix: '/7eww0j5l7zpf',
          target: 'images.ctfassets.net/7eww0j5l7zpf'
        },
        { // WSS
          prefix: '/wire-unity',
          target: 'wire.unity3d.com'
        },
        { // WSS Alex
          prefix: '/wss-alex',
          target: 'bj.alisterion.com'
        }
      ]);
      if (!authingRef.current) { 
        authingRef.current = true;
        const { code } = await discordSdk.commands.authorize({
          client_id: discordAppId,
          response_type: "code",
          state: "",
          prompt: "none",
          scope: [
            "identify",
            "email",
            "guilds",
            "guilds.join",
            "guilds.members.read",
            "applications.commands"
          ],
        });
        const token = await getDiscordToken(code);
        const auth = await discordSdk.commands.authenticate({ access_token: token });
        if (auth == null) {
          console.error("Authenticate command failed");
        }
        setDiscordToken(token);
        setDiscordSdk(discordSdk);
        setIsDiscord(true);
      } else {
        keepLoading = true;
      }
    } catch (err) {
      setIsDiscord(false);
    } finally {
      if (!keepLoading) {
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    setupSdk();
  }, []);

  const buySku = async (skuId) => {
    await discordSdk.commands.startPurchase({sku_id: skuId});
  };

  const invite = async () => {
    await discordSdk.commands.openInviteDialog();
  };

  const joinServer = async () => {
    await discordSdk.commands.openExternalLink({ url: DISCORD_SERVER_INVITE_URL });
  };

  const value = {
    isLoading,
    isDiscord,
    buySku,
    invite,
    joinServer,
    discordSdk,
    discordToken,
    setDiscordToken
  };

  return (
    <DiscordSdkContext.Provider value={value}>
      {children}
    </DiscordSdkContext.Provider>
  );
};
